import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Shareservice extends Component {
  render() {
    return (

      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="shareservice" className="a-breadcrumbs">บริการหุ้น</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{fontFamily: '"Cordia New"',fontSize: 20}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>บริการหุ้น</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <p className="mb-20">ตามข้อบังคับของสหกรณ์ออมทรัพย์ไทยออยล์ จำกัด สมาชิกสหกรณ์ทุกคน ต้องส่งค่าหุ้นรายเดือนนับแต่เดือนแรกเข้าเป็นสมาชิก โดยอัตราค่าหุ้นรายเดือน และจำนวนมูลค่าหุ้นที่สมาชิกจะต้องถือนั้น เป็นไปตามระเบียบ และประกาศที่สหกรณ์กำหนด</p>
                <p className="mb-20">ปัจจุบันอัตราค่าหุ้นมีมูลค่า 100.- บาทต่อหุ้น สมาชิกจะต้องส่งค่าหุ้นรายเดือนขั้นต่ำ 100 บาท และสูงสุดได้ไม่เกิน 20%  ของเงินได้สุทธิรายเดือน สมาชิกรายหนึ่งๆจะถือหุ้นได้ไม่เกิน 30 ล้านบาท</p>
                {/* list*/}
                <h3>การเปลี่ยนแปลงค่าหุ้นรายเดือน</h3>
                <p className="mb-20">การเปลี่ยนแปลงค่าหุ้นรายเดือน ได้แก่ การเพิ่มและลดส่งหุ้น หากสมาชิกมีความประสงค์เปลี่ยนแปลงค่าหุ้นรายเดือน  สามารถยื่นคำร้องภายในวันที่ 10 ของแต่ละเดือน โดยสมาชิกสามารถเปลี่ยนแปลงได้ตามเงื่อนไข ดังนี้</p>
                <h3><u>ตาราง การเปลี่ยนแปลงค่าหุ้นรายเดือน</u></h3>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>คำขอเปลี่ยนแปลง</th>
                      <th>เงื่อนไข</th>
                      <th>จำนวนครั้งต่อปี</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>การเพิ่มหุ้น</td>
                      <td>ไม่เกิน 20%  ของเงินได้สุทธิรายเดือน</td>
                      <td>ไม่จำกัด</td>
                    </tr>
                    <tr>
                      <td>การลดหุ้น</td>
                      <td>ส่งค่าหุ้นรายเดือนมาแล้วไม่น้อยกว่า 84 เดือน หรือมีเงินค่าหุ้นไม่น้อยกว่า 20,000.- บาท</td>
                      <td>ได้ไม่เกิน 2 ครั้งต่อปี</td>
                    </tr>
                  </tbody>
                </table>
                <p className="mb-20">หมายเหตุ   หากยื่นคำร้องหลังวันที่ 10 จะมีผลเดือนถัดไป</p>
                <p className="mb-20">ยื่นคำร้องได้ที่&nbsp;&nbsp;&nbsp;<u><a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" target="_blank" style={{color: '#4db6f1'}}>ระบบข้อมูลสมาชิกออนไลน์</a></u></p>
                <h3>การซื้อหุ้นพิเศษ</h3>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>เงินได้กรณีพิเศษ</th>
                      <th>จำนวนเงินที่ซื้อได้</th>
                      <th>ระยะเวลา</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>เงินบำเหน็จครบอายุงาน</td>
                      <td>ตามที่ได้รับจริง</td>
                      <td rowSpan={2}>ภายใน 30 วันหลังจากที่ได้รับเงิน</td>
                    </tr>
                    <tr>
                      <td>เงินได้ในโอกาสเกษียณอายุงาน</td>
                      <td>ตามที่ได้รับจริง</td>
                    </tr>
                    <tr>
                      <td>เงินได้กองทุนสำรองเลี้ยงชีพ</td>
                      <td>ตามที่ได้รับจริง</td>
                      <td>ภายใน 6 เดือน หลังจากเกษียณอายุงาน สำหรับสมาชิกที่เกษียณก่อนหน้านี้  จะต้องดำเนินการภายใน 31 ม.ค. 2565</td>
                    </tr>
                    <tr>
                      <td>เงินโบนัส</td>
                      <td>ตามที่ได้รับจริงแต่ไม่เกิน 100,000 บาท</td>
                      <td rowSpan={3}>ตามวันเวลาที่สหกรณ์กำหนด</td>
                    </tr>
                    <tr>
                      <td>เงินรางวัลการปฏิบัติงาน (สำหรับเงินเดือนเต็มขั้น)</td>
                      <td>ไม่เกินร้อยละ 20 ของจำนวนเงินที่ได้รับจริงและไม่เกิน 50,000 บาท</td>
                    </tr>
                    <tr>
                      <td>เงินปันผลและเฉลี่ยคืน</td>
                      <td>ตามที่ได้รับจริงแต่ไม่เกิน 500,000 บาท</td>
                    </tr>
                  </tbody>
                </table>
                <p className="mb-20">หมายเหตุ 	สำหรับสมาชิกที่มีความประสงค์จะซื้อหุ้นพิเศษ  ต้องยื่นคำร้องและชำระเงินค่าหุ้นภายในกำหนด</p>
                <p className="mb-20">ยื่นคำร้องได้ที่&nbsp;&nbsp;&nbsp;<u><a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" target="_blank" style={{color: '#4db6f1'}}>ระบบข้อมูลสมาชิกออนไลน์</a></u></p>
                <h3>การลาออก</h3>
                <p className="mb-20">
                </p><ul>
                  <li>1. ลาออกได้ปีละ 1 ครั้ง โดยเสียค่าธรรมเนียม 100 บาท ต่อการสมัครแต่ละครั้ง</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1 ลาออกและสมัครใหม่ทันที นำเงินค่าหุ้นกลับมาได้ไม่เกินมูลค่าหุ้นที่มีอยู่ก่อนลาออกหักด้วยภาระหนี้ (อดีตพนักงานไม่น้อยกว่า 100,000 บาท)</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2 ลาออกแต่ไม่สมัครใหม่ทันที</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2.1 สมาชิกปัจจุบัน ไม่สามารถนำเงินค่าหุ้นกลับมาได้</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2.2 สมาชิกอดีตพนักงาน ไม่สามารถกลับมาสมัครเป็นสมาชิกได้อีก</li>
                  <li>2. สมาชิกปัจจุบันสิ้นสุดการเป็นพนักงาน และมีหุ้นน้อยกว่า 100,000 บาท</li>
                </ul>
                <p />
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}

export default Shareservice;
